import { Component, Input } from '@angular/core';

@Component({
  selector: 'next-svg-embedded',
  templateUrl: './svg-embedded.component.html',
  styleUrls: ['./svg-embedded.component.css']
})
export class SvgEmbeddedComponent {

  @Input() src: string;

}
